/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FacilityPayorConfig } from './FacilityPayorConfig';
import {
    FacilityPayorConfigFromJSON,
    FacilityPayorConfigFromJSONTyped,
    FacilityPayorConfigToJSON,
} from './FacilityPayorConfig';

/**
 * 
 * @export
 * @interface GetPayorConfigForFacility200Response
 */
export interface GetPayorConfigForFacility200Response {
    /**
     * 
     * @type {FacilityPayorConfig}
     * @memberof GetPayorConfigForFacility200Response
     */
    data?: FacilityPayorConfig;
}

/**
 * Check if a given object implements the GetPayorConfigForFacility200Response interface.
 */
export function instanceOfGetPayorConfigForFacility200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetPayorConfigForFacility200ResponseFromJSON(json: any): GetPayorConfigForFacility200Response {
    return GetPayorConfigForFacility200ResponseFromJSONTyped(json, false);
}

export function GetPayorConfigForFacility200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPayorConfigForFacility200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : FacilityPayorConfigFromJSON(json['data']),
    };
}

export function GetPayorConfigForFacility200ResponseToJSON(value?: GetPayorConfigForFacility200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': FacilityPayorConfigToJSON(value.data),
    };
}

